export default {
    name: "SettingsUserManagementHeader",

    props: {
        users_count: {
            type: Number,
            default: 0
        },
        active_users_count: {
            type: Number,
            default: 0
        }
    },

    emits: ["open-add-user"]
};
